var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.375H24V14.625H0V9.375Z",
    fill: "#90A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75C1.26488 3.75 0 5.59688 0 7.875V9.375H24V7.875C24 5.59688 22.7351 3.75 20.25 3.75Z",
    fill: "#90A4AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.125C0 18.4031 1.26488 20.25 3.75 20.25H20.25C22.7351 20.25 24 18.4031 24 16.125V14.625H0V16.125Z",
    fill: "#90A4AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 6.875V17.1875H13.4375V6.875H7.8125ZM7.34375 5.9375H13.9062C14.0306 5.9375 14.1498 5.98689 14.2377 6.07479C14.3256 6.1627 14.375 6.28193 14.375 6.40625V17.6562C14.375 17.7806 14.3256 17.8998 14.2377 17.9877C14.1498 18.0756 14.0306 18.125 13.9062 18.125H7.34375C7.21943 18.125 7.1002 18.0756 7.01229 17.9877C6.92439 17.8998 6.875 17.7806 6.875 17.6562V6.40625C6.875 6.28193 6.92439 6.1627 7.01229 6.07479C7.1002 5.98689 7.21943 5.9375 7.34375 5.9375Z",
    fill: "#F7F9FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.75H12.5V9.6875H8.75V8.75ZM8.75 11.5625H12.5V12.5H8.75V11.5625ZM8.75 14.375H12.5V15.3125H8.75V14.375ZM14.375 12.5H16.25V13.4375H14.375V12.5ZM14.375 14.375H16.25V15.3125H14.375V14.375ZM5.9375 17.1875H19.0625V18.125H5.9375V17.1875Z",
    fill: "#F7F9FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 10.625V17.1875H17.1875V10.625H14.375ZM13.9062 9.6875H17.6562C17.7806 9.6875 17.8998 9.73689 17.9877 9.82479C18.0756 9.9127 18.125 10.0319 18.125 10.1562V17.6562C18.125 17.7806 18.0756 17.8998 17.9877 17.9877C17.8998 18.0756 17.7806 18.125 17.6562 18.125H13.9062C13.7819 18.125 13.6627 18.0756 13.5748 17.9877C13.4869 17.8998 13.4375 17.7806 13.4375 17.6562V10.1562C13.4375 10.0319 13.4869 9.9127 13.5748 9.82479C13.6627 9.73689 13.7819 9.6875 13.9062 9.6875Z",
    fill: "#F7F9FB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.7cc9c647661ccd42a95531608884d220.svg";
export { ForwardRef as ReactComponent };